module.exports = __webpack_public_path__ + "static/google-logo-transparent-46727f93eee0eafae95173dffc49d556.png";